/** 保存图片/文件：Android 走原生 MediaStore，浏览器走下载链接。 */

function safeName(name: string, fallback: string): string {
  const cleaned = name.replace(/[\\/:*?"<>|]+/g, '_').trim();
  return (cleaned || fallback).slice(0, 160);
}

function clickDownload(dataUrl: string, name: string): void {
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function saveChatImage(dataUrl: string, name = '余白图片.png'): void {
  const fileName = safeName(name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.webp') ? name : `${name}.png`, '余白图片.png');
  if (window.XiaotianshuAndroid?.saveImage) {
    window.XiaotianshuAndroid.saveImage(dataUrl, fileName);
    return;
  }
  clickDownload(dataUrl, fileName);
}

export function saveChatFile(dataUrl: string, name: string, mimeType = 'application/octet-stream'): void {
  const fileName = safeName(name, '余白文件');
  if (window.XiaotianshuAndroid?.saveFile) {
    window.XiaotianshuAndroid.saveFile(dataUrl, fileName, mimeType);
    return;
  }
  clickDownload(dataUrl, fileName);
}
